import React from 'react';
type StatusType = 'paid' | 'due-soon' | 'overdue' | 'installments' | 'active' | 'paused' | 'canceled' | 'pending' | 'draft' | 'published' | 'sdi-sent' | 'sdi-accepted' | 'sdi-rejected' | 'payment-failed' | 'payment-pending';
interface StatusChipProps {
  status: StatusType;
  label?: string;
}
export function StatusChip({
  status,
  label
}: StatusChipProps) {
  const statusConfig = {
    paid: {
      bg: 'bg-[#00C853]/20',
      text: 'text-[#00C853]',
      defaultLabel: 'Pagato'
    },
    'due-soon': {
      bg: 'bg-[#FFB84D]/20',
      text: 'text-[#FFB84D]',
      defaultLabel: 'In Scadenza'
    },
    overdue: {
      bg: 'bg-[#FF6B81]/20',
      text: 'text-[#FF6B81]',
      defaultLabel: 'Scaduto'
    },
    installments: {
      bg: 'bg-[#7B68EE]/20',
      text: 'text-[#7B68EE]',
      defaultLabel: 'Rate Attive'
    },
    active: {
      bg: 'bg-[#00C853]/20',
      text: 'text-[#00C853]',
      defaultLabel: 'Attivo'
    },
    paused: {
      bg: 'bg-[#FFB84D]/20',
      text: 'text-[#FFB84D]',
      defaultLabel: 'In Pausa'
    },
    canceled: {
      bg: 'bg-gray-100',
      text: 'text-gray-600',
      defaultLabel: 'Cancellato'
    },
    pending: {
      bg: 'bg-[#1DA1F2]/20',
      text: 'text-[#1DA1F2]',
      defaultLabel: 'In Attesa'
    },
    draft: {
      bg: 'bg-gray-100',
      text: 'text-gray-600',
      defaultLabel: 'Bozza'
    },
    published: {
      bg: 'bg-[#00C853]/20',
      text: 'text-[#00C853]',
      defaultLabel: 'Pubblicato'
    },
    'sdi-sent': {
      bg: 'bg-[#1DA1F2]/20',
      text: 'text-[#1DA1F2]',
      defaultLabel: 'Inviato a SDI'
    },
    'sdi-accepted': {
      bg: 'bg-[#00C853]/20',
      text: 'text-[#00C853]',
      defaultLabel: 'Accettato da SDI'
    },
    'sdi-rejected': {
      bg: 'bg-[#FF6B81]/20',
      text: 'text-[#FF6B81]',
      defaultLabel: 'Rifiutato da SDI'
    },
    'payment-failed': {
      bg: 'bg-[#FF6B81]/20',
      text: 'text-[#FF6B81]',
      defaultLabel: 'Pagamento Fallito'
    },
    'payment-pending': {
      bg: 'bg-[#FFB84D]/20',
      text: 'text-[#FFB84D]',
      defaultLabel: 'Pagamento in Attesa'
    }
  };
  const config = statusConfig[status];
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`} data-id="element-1518">
      {label || config.defaultLabel}
    </span>;
}